import { render } from "./ResendActivation.vue?vue&type=template&id=4e64811f&scoped=true"
import script from "./ResendActivation.vue?vue&type=script&lang=js"
export * from "./ResendActivation.vue?vue&type=script&lang=js"

import "./ResendActivation.vue?vue&type=style&index=0&id=4e64811f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e64811f"]])

export default __exports__